import React, { useEffect } from "react";
import {
  Button,
  Dropdown,
  Menu,
  message,
  Modal,
  Popconfirm,
  Tooltip,
} from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { createComponentStore, useStoreState } from "easy-peasy";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RECORD_STATE } from "Constants";
import {
  HousingScoringStoreModel,
  ACTION_TYPES,
} from "store/models/master-data/housing-scoring";

const useStore = createComponentStore(HousingScoringStoreModel);

export default function OperationsColumn({
  collapsed = false,
  record,
  onOperationExecuted,
  ...props
}) {
  const history = useHistory();
  const match = useRouteMatch();

  const { abilities } = useStoreState((store) => store.auth);
  const [store, actions] = useStore();

  const { process } = store;
  const { remove, restore } = actions;

  useEffect(() => {
    switch (process) {
      case ACTION_TYPES.REMOVED_DATA:
        message.success("Konut puanlama formu kaldırıldı.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.RESTORED_DATA:
        message.success("Konut puanlama formu arşivden geri alındı.");
        onOperationExecuted();
        break;
      default:
        break;
    }
  }, [process]);

  const handleActions = (key, record) => {
    switch (key) {
      case "detail":
        if (record.state === RECORD_STATE.ACTIVE)
          history.push(`${match.path}/${record.id}/detay`);
        else history.push(`${match.path}/${record.id}/arsiv`);
        break;
      case "edit":
        history.push(`${match.path}/${record.id}/duzenle`);
        break;
      case "remove":
        Modal.confirm({
          title: "Sil",
          content:
            "Bu konut puanlama formunu silmek istediğinize emin misiniz?",
          okText: "Evet",
          cancelText: "İptal",
          onOk: () => remove({ id: record.id, version: record.version }),
        });
        break;
      case "restore":
        restore({ id: record.id, version: record.version });
        break;
      default:
        break;
    }
  };
  return !collapsed ? (
    <span>
      <Tooltip title="Görüntüle">
        <Button
          style={{ marginRight: 8 }}
          onClick={() => {
            handleActions("detail", record);
          }}
        >
          <FontAwesomeIcon icon={["far", "eye"]} />
        </Button>
      </Tooltip>

      {record.state === RECORD_STATE.ACTIVE &&
        AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Konut Puanlama Formları") && (
          <Tooltip title="Düzenle">
            <Button
              style={{ marginRight: 8 }}
              onClick={() => {
                handleActions("edit", record);
              }}
            >
              <FontAwesomeIcon icon={["far", "edit"]} />
            </Button>
          </Tooltip>
        )}

      {record.state === RECORD_STATE.ACTIVE &&
        AuthCheck(
          abilities,
          AUTH_ACTIONS.DELETE,
          "Konut Puanlama Formları"
        ) && (
          <Tooltip title="Kaldır" placement="bottom">
            <Button
              type="danger"
              onClick={() => {
                handleActions("remove", record);
              }}
            >
              <FontAwesomeIcon icon={["far", "trash-alt"]} />
            </Button>
          </Tooltip>
        )}

      {record.state === RECORD_STATE.DELETED &&
        AuthCheck(
          abilities,
          AUTH_ACTIONS.RESTORE_ARCHIVE,
          "Konut Puanlama Formları"
        ) && (
          <Tooltip title="Geri Al" placement="bottom">
            <Button
              onClick={() => {
                handleActions("restore", record);
              }}
            >
              <FontAwesomeIcon icon={["fas", "recycle"]} />
            </Button>
          </Tooltip>
        )}
    </span>
  ) : (
    <Dropdown
      trigger="click"
      placement="bottomRight"
      overlay={
        <Menu onClick={(item) => handleActions(item.key, record)}>
          <Menu.Item key="detail">
            <FontAwesomeIcon
              icon={["far", "eye"]}
              style={{ marginRight: 8, width: 24 }}
            />
            Görüntüle
          </Menu.Item>

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(
              abilities,
              AUTH_ACTIONS.WRITE,
              "Konut Puanlama Formları"
            ) && (
              <Menu.Item key="edit">
                <FontAwesomeIcon
                  icon={["far", "edit"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Düzenle
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(
              abilities,
              AUTH_ACTIONS.DELETE,
              "Konut Puanlama Formları"
            ) && (
              <Menu.Item key="remove">
                <FontAwesomeIcon
                  icon={["far", "trash-alt"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Sil
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.DELETED &&
            AuthCheck(
              abilities,
              AUTH_ACTIONS.RESTORE_ARCHIVE,
              "Konut Puanlama Formları"
            ) && (
              <Menu.Item key="restore">
                <FontAwesomeIcon
                  icon={["fas", "recycle"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Geri Al
              </Menu.Item>
            )}
        </Menu>
      }
    >
      <Button>
        <FontAwesomeIcon icon={["fas", "ellipsis-h"]} />
      </Button>
    </Dropdown>
  );
}
